import { X } from "lucide-react";
import PropTypes from "prop-types";
import classnames from "classnames";

const WIDTH_CLASS = {
    sm: "max-w-md",
    md: "max-w-lg",
    lg: "max-w-2xl",
    // Wide enough to read an embedded document (see the publisher contract
    // review modal) rather than skim it.
    xl: "max-w-4xl"
};

const Modal = ({ open, title, subtitle, onClose, width = "sm", children, footer }) => {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[210] flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-navy/60 backdrop-blur-[2px]" onClick={onClose} />
            <div className={classnames("relative w-full rounded-xl bg-white p-6 shadow-2xl", WIDTH_CLASS[width])}>
                <div className="flex items-start justify-between gap-3">
                    <div>
                        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
                        {subtitle && <p className="mt-1 text-sm text-muted">{subtitle}</p>}
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-gray-400 hover:text-gray-600">
                        <X className="h-4.5 w-4.5" />
                    </button>
                </div>

                <div className="mt-5">{children}</div>

                {footer && (
                    <div className="mt-6 flex items-center justify-end gap-3">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
};

Modal.propTypes = {
    open    : PropTypes.bool.isRequired,
    title   : PropTypes.node.isRequired,
    subtitle: PropTypes.node,
    onClose : PropTypes.func.isRequired,
    width   : PropTypes.oneOf(["sm", "md", "lg", "xl"]),
    children: PropTypes.node,
    footer  : PropTypes.node
};

export default Modal;
